<cc-settings-block [ngClass]="'list-container'">
  <cc-settings-header
    [ngStyle]="{borderBottom: 'none'}"
    header="{{ 'WEBHOOKS.LIST' | translate }}">
    <cc-webhook-types-dropdown *ngIf="filterByTypeAvailable()"
                               (selectionChanged)="filterList($event)"
    ></cc-webhook-types-dropdown>
  </cc-settings-header>

  <mat-table
    [dataSource]="dataSource"
  >
    <ng-container matColumnDef="webhookName">
      <mat-header-cell *matHeaderCellDef
                       [ngClass]="'mat-column-name'"> {{ 'WEBHOOKS.NAME' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="'mat-column-name'">
        {{element.name}}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="active">
      <mat-header-cell *matHeaderCellDef
                       [ngClass]="'mat-column-actions'"> {{ 'WEBHOOKS.ACTIVE' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="'mat-column-actions'">
        <ui-switch [checked]="element.active"
                   (change)="changeActive(element)"
        ></ui-switch>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef [ngClass]="'mat-column-actions'"></mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="'mat-column-actions'">
        <i class="material-icons actionIcon" (click)="edit(element)">create</i>
        <i class="material-icons actionIcon" (click)="delete(element)">delete</i>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>


</cc-settings-block>
